import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueFullPage from 'vue-fullpage.js';
import VueCookie from "vue-cookie";
import Vuetify from "vuetify";

import '@mdi/font/css/materialdesignicons.css'

import "@/stylesheets/Fonts.scss";
import 'vuetify/dist/vuetify.min.css';

Vue.use(VueFullPage);
Vue.use(VueCookie);
Vue.config.productionTip = false;

const vuetify = new Vuetify(
    {
      options: {
        customProperties: true
      },
      theme: {
        themes: {
          light: {
            primary: '#000',
            secondary: '#000',
            accent: '#000',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107'
          }
        }
      }}
);

Vue.use(Vuetify);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

